export interface DocumentTableRow {
  documentName: string;
  folderKey: string;
  folderName: string;
  hasBeenViewed: boolean;
  createdOn: string;
  uploadedBy: string;
  actionButton: string;
}

export interface FolderTableRow {
  folderKey: string;
  folderName: string;
  documents: DocumentTableRow[];
  createdOn: string;
  createdBySub: string;
}

export interface GetDocumentRequest {
  name: string;
  type: DocumentTypes;
}

export interface GetDocumentResponse {
  preSignedUrl: string;
}

export interface SaveDocumentRequest {
  documentType: DocumentTypes;
  documentName: string;
  base64Document: string;
}

export interface DeleteDocumentRequest {
  documentType: DocumentTypes;
  documentName: string;
}

export enum DocumentMimeTypes {
  PDF = 'application/pdf',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MP4 = 'video/mp4',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}

export enum DocumentTypes {
  CONTRACTS_AND_AGREEMENTS = 'contracts-and-agreements',
  ESTIMATES = 'estimates',
  CHANGE_ORDERS = 'change-orders',
  SITE_PLANS_AND_SURVEYS = 'site-plans-and-surveys',
  HOME_PRINTS_AND_RENDERINGS = 'home-prints-and-renderings',
  PERMITS = 'permits',
  MEDIA = 'media',
  FACTORY_ORDER = 'factory-order',
  OTHER = 'other',
  ARCHIVE = 'archive',
  PRICING_DASHBOARD = 'pricing-dashboard',
}

export interface Document {
  documentName: string;
  hasBeenViewed: boolean;
  createdBySub: string;
  createdByFirstName: string;
  createdByLastName: string;
  createdOn: string;
}

export interface DocumentTree {
  [key: string]: Document[];
}

export interface DocumentHubResponse {
  documentTree: DocumentTree;
}

export interface DocumentHubResponse {
  sub: string;
  documentTree: DocumentTree;
}

export interface PricingDashboardDocumentsResponse {
  sub: string;
  'pricing-dashboard': {
    documentName: string;
    hasBeenViewed: boolean;
    createdBySub: string;
    createdByFirstName: string;
    createdByLastName: string;
    createdOn: string;
  }[];
}

export const Folders = {
  'change-orders': 'Change Orders',
  'contracts-and-agreements': 'Contracts and Agreements',
  estimates: 'Estimates',
  'factory-order': 'Factory Order',
  media: 'Media',
  other: 'Other',
  permits: 'Permits',
  'site-plans-and-surveys': 'Site Plans and Surveys',
};
